import { render, staticRenderFns } from "./FormulaireDemission.vue?vue&type=template&id=196c3ec9"
import script from "./FormulaireDemission.vue?vue&type=script&lang=js"
export * from "./FormulaireDemission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports